var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box';
import { CloseButton, CloseButtonSpacer } from '../tools/components';
import { a11y } from './strings';
var StyledWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.16),\n    0 5px 8px -4px rgba(0, 0, 0, 0.16);\n  position: relative;\n  border-radius: 4px;\n\n  ", "\n"], ["\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.16),\n    0 5px 8px -4px rgba(0, 0, 0, 0.16);\n  position: relative;\n  border-radius: 4px;\n\n  ", "\n"])), function (_a) {
    var colors = _a.theme.colors;
    return colors.white;
}, function (_a) {
    var colors = _a.theme.colors;
    return colors['gray-300'];
}, function (_a) {
    var media = _a.theme.media, isFullScreenSmDown = _a.isFullScreenSmDown;
    return isFullScreenSmDown
        ? "\n            ".concat(media.down('sm'), " {\n                border-radius: unset;\n                width: 100%;\n            }\n        ")
        : "";
});
var Card = function (_a) {
    var _b = _a.closeButton, closeButton = _b === void 0 ? true : _b, children = _a.children, onClickCloseButton = _a.onClickCloseButton, isFullScreenSmDown = _a.isFullScreenSmDown, className = _a.className, _c = _a.ariaLabelCloseButton, ariaLabelCloseButton = _c === void 0 ? closeButton ? a11y.ariaLabelCloseButton : undefined : _c;
    return (React.createElement(StyledWrapper, { isFullScreenSmDown: isFullScreenSmDown, className: className },
        closeButton && (React.createElement(CloseButtonSpacer, { isFullScreenSmDown: isFullScreenSmDown })),
        React.createElement(Box, { p: "md" }, children),
        closeButton && (React.createElement(CloseButton, { "data-testid": "close-button", "data-track-elem": "icon", "data-track-name": "Close", "data-track-trigger": "close", onClick: onClickCloseButton, ariaLabel: ariaLabelCloseButton }))));
};
export { Card };
var templateObject_1;
//# sourceMappingURL=Card.js.map